export default function iframeResize(height = 0) {
    if (window.parent) {
        window.parent.postMessage(
            {
                type: 'parlay:iframe-resize',
                payload: {
                    height: `${height || document.body.scrollHeight}px`,
                },
            },
            '*'
        );
    }
}
